import React, {useState} from 'react';
import { useTranslation } from 'react-i18next';
import {useDispatch} from "react-redux";
import {closeDialog} from "../../../../store/actionCreators/dialog";
import { removeMemberRequest } from "../../../../store/actionCreators/member";

const MemberInfo =({memberId}) => {
  const { t } = useTranslation();
    const dispatch = useDispatch();
    const [memberAlias, setMemberAlias] = useState('');
    const [memberNotes, setMemberNotes] = useState('');

    const close = () => {
        dispatch(closeDialog());
    };
    const insertAlias = (e) => {
        setMemberAlias(e.target.value);
    };
    const insertNotes = (e) => {
        setMemberNotes(e.target.value);
    };

    return (
        <div className={`editMemberInfoContent`}>
            <div className="fieldsSection">
                <div className={`addAlias field`}>
                    {t('memberDetails.editMemberInfo.alias')}
                    <label>
                        <input type="text" onChange={(e) => insertAlias(e)} />
                    </label>
                </div>

                <div className={`addNotes field`}>
                    {t('memberDetails.editMemberInfo.notes')}
                    <label>
                        <textarea max="256" onChange={(e) => insertNotes(e)} />
                    </label>
                </div>
            </div>

            <div className={`dialogConfirmBox`}>
                <button className="primary" className={`confirm`} >{t('button.save')}</button>
            </div>
        </div>
    );
};

export default MemberInfo;
